// extracted by mini-css-extract-plugin
export default {"card":"_home_card__F1mBO"};